import Vue from 'vue'
import WtkMessage from "@/components/message/WtkMessage";
import VtkProj from "@/components/assembly/VtkProj"//目录选择
import VtkFormItem from "@/components/assembly/VtkFormItem"//目录选择
import VtkAreaTabs from "@/components/assembly/VtkAreaTabs"//选择地区
import VtkAreaTree from "@/components/assembly/VtkAreaTree"//选择地区




// Vue.prototype.$message = MessageModals;

const components = [
    WtkMessage,
    VtkProj,
    VtkFormItem,
    VtkAreaTabs,
    VtkAreaTree
]

components.forEach(component => {
    Vue.component(component.name, component);
});

export default {
    WtkMessage,
    VtkProj,
    VtkFormItem,
    VtkAreaTabs,
    VtkAreaTree
}

